import { Controller } from "@hotwired/stimulus"
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

export default class extends Controller {
  static targets = [ "geoinput", "suggestions", "full", "lat", "lng", "code2" ]

  connect() {
    let _this = this;

    if (document.querySelector("md-dialog") != null)
      document.querySelector("md-dialog").addEventListener('opened', () => {
        _this.init(_this);
      });
    else
      _this.init(_this);

  }

  init(_this) {
    if (_this.hasGeoinputTarget) {
      let center = [_this.lngTarget.value , _this.latTarget.value ];
      mapboxgl.accessToken = _this.geoinputTarget.dataset.token;

      const map = new mapboxgl.Map({
        container: 'geosearch-map', // container ID
        style: 'mapbox://styles/mapbox/streets-v12', // style URL
        center: center, // starting position [lng, lat]
        zoom: 14 // starting zoom
      });

      let suggestionList = _this.suggestionsTarget;

      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        marker: false,
        language: 'en-US', // Specify the language as German.
        flyTo: false // we'll handle flyTo manually
      });

      geocoder.onAdd(map);

      let marker = new mapboxgl.Marker().setLngLat(center).addTo(map);

      geocoder.on('result', (e) => {
        if (!e.result?.center) return;
        const [lng, lat] = e.result.center;

        if (!marker) {
          marker = new mapboxgl.Marker().setLngLat([lng, lat]).addTo(map);
        } else {
          marker.setLngLat([lng, lat]);
        }

        map.flyTo({ center: [lng, lat], zoom: 14 });
      });

      let latestQuery = '';

      // Run query and update suggestions
      const updateSuggestions = debounce((query) => {
        if (!query.trim()) {
          suggestionList.innerHTML = '';
          return;
        }

        geocoder.query(query);
        latestQuery = query;
      }, 300);

      // Listen for input
      _this.geoinputTarget.addEventListener('input', (e) => {
        updateSuggestions(e.target.value);
      });


      // When geocoder gets results, populate dropdown
      geocoder.on('results', (e) => {
        const results = e.features || [];
        suggestionList.innerHTML = '';

        results.forEach((feature) => {
          const item = document.createElement('li');
          item.textContent = feature.place_name;
          item.style.padding = '8px';
          item.style.cursor = 'pointer';
          item.addEventListener('click', () => {
            const [lng, lat] = feature.center;
            map.flyTo({ center: [lng, lat], zoom: 14 });
            marker.setLngLat([lng, lat]);

            _this.setInputsFrom(feature);

            suggestionList.innerHTML = '';
          });

          suggestionList.appendChild(item);
        });
      });

    } else if (_this.element.querySelector("#show-map")) {

      let center = [_this.element.dataset.lng , _this.element.dataset.lat ];
      mapboxgl.accessToken = _this.element.dataset.token;

      const map = new mapboxgl.Map({
        container: 'show-map', // container ID
        style: 'mapbox://styles/mapbox/streets-v12', // style URL
        center: center, // starting position [lng, lat]
        zoom: 14 // starting zoom
      });

      map.addControl(new mapboxgl.NavigationControl());

      let marker = new mapboxgl.Marker().setLngLat(center).addTo(map);
    }
  }

  setInputsFrom(feature) {
    let _this = this;
    const [lng, lat] = feature.center;

    _this.geoinputTarget.value = feature.place_name;
    _this.latTarget.value = lat;
    _this.lngTarget.value = lng
    _this.code2Target.value = feature.place_name;
  }
}


// Debounce to reduce requests
function debounce(fn, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}
